import Vue3Lottie from "vue3-lottie";

export default defineNuxtPlugin({
    parallel: true,
    async setup(nuxtApp) {
        nuxtApp.vueApp.use(Vue3Lottie);
    },
});
